import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addJob, getJobCategories } from "../../slice/workerJobSlice";
import { toast } from "react-toastify";
import QuillEditor from "../text_editor";
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    TextField,
    FormControl,
    FormLabel,
    InputLabel,
    Select,
    MenuItem,
    RadioGroup,
    FormControlLabel,
    Radio,
    Paper,
    Grid,
    Typography,
    Divider
} from "@mui/material";

const stats = [
    { id: 1, code: 'AL', name: 'Alabama' },
    { id: 2, code: 'AK', name: 'Alaska' },
    { id: 3, code: 'AZ', name: 'Arizona' },
    { id: 4, code: 'AR', name: 'Arkansas' },
    { id: 5, code: 'CA', name: 'California' },
    { id: 6, code: 'CO', name: 'Colorado' },
    { id: 7, code: 'CT', name: 'Connecticut' },
    { id: 8, code: 'DE', name: 'Delaware' },
    { id: 9, code: 'FL', name: 'Florida' },
    { id: 10, code: 'GA', name: 'Georgia' },
    { id: 11, code: 'HI', name: 'Hawaii' },
    { id: 12, code: 'ID', name: 'Idaho' },
    { id: 13, code: 'IL', name: 'Illinois' },
    { id: 14, code: 'IN', name: 'Indiana' },
    { id: 15, code: 'IA', name: 'Iowa' },
    { id: 16, code: 'KS', name: 'Kansas' },
    { id: 17, code: 'KY', name: 'Kentucky' },
    { id: 18, code: 'LA', name: 'Louisiana' },
    { id: 19, code: 'ME', name: 'Maine' },
    { id: 20, code: 'MD', name: 'Maryland' },
    { id: 21, code: 'MA', name: 'Massachusetts' },
    { id: 22, code: 'MI', name: 'Michigan' },
    { id: 23, code: 'MN', name: 'Minnesota' },
    { id: 24, code: 'MS', name: 'Mississippi' },
    { id: 25, code: 'MO', name: 'Missouri' },
    { id: 26, code: 'MT', name: 'Montana' },
    { id: 27, code: 'NE', name: 'Nebraska' },
    { id: 28, code: 'NV', name: 'Nevada' },
    { id: 29, code: 'NH', name: 'New Hampshire' },
    { id: 30, code: 'NJ', name: 'New Jersey' },
    { id: 31, code: 'NM', name: 'New Mexico' },
    { id: 32, code: 'NY', name: 'New York' },
    { id: 33, code: 'NC', name: 'North Carolina' },
    { id: 34, code: 'ND', name: 'North Dakota' },
    { id: 35, code: 'OH', name: 'Ohio' },
    { id: 36, code: 'OK', name: 'Oklahoma' },
    { id: 37, code: 'OR', name: 'Oregon' },
    { id: 38, code: 'PA', name: 'Pennsylvania' },
    { id: 39, code: 'RI', name: 'Rhode Island' },
    { id: 40, code: 'SC', name: 'South Carolina' },
    { id: 41, code: 'SD', name: 'South Dakota' },
    { id: 42, code: 'TN', name: 'Tennessee' },
    { id: 43, code: 'TX', name: 'Texas' },
    { id: 44, code: 'UT', name: 'Utah' },
    { id: 45, code: 'VT', name: 'Vermont' },
    { id: 46, code: 'VA', name: 'Virginia' },
    { id: 47, code: 'WA', name: 'Washington' },
    { id: 48, code: 'WV', name: 'West Virginia' },
    { id: 49, code: 'WI', name: 'Wisconsin' },
    { id: 50, code: 'WY', name: 'Wyoming' },
];

const WorkerAddJobAI = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { jobCategories, loading } = useSelector((state) => state.workerJob);
    const [activeStep, setActiveStep] = useState(0);

    const defaultExpiresAt = new Date();
    defaultExpiresAt.setDate(defaultExpiresAt.getDate() + 30);
    const defaultExpiresAtString = defaultExpiresAt.toISOString().split("T")[0];

    const [form, setForm] = useState({
        role_id: "",
        title: "",
        categories: "",
        job_type: "",
        status: "published",
        experience_level: "",
        city: "",
        state: "",
        salary_min: "",
        salary_max: "",
        currency: "USD",
        salary_type: "yearly",
        duration: "",
        no_of_jobs: "",
        description: "",
        fixed: "",
        careerlevel: "",
        country: "US",
        expires_at: defaultExpiresAtString,
        remote: "0",
        career_level: "1"
    });

    const steps = [
        "Select Role",
        "Location & Salary",
        "Additional Info",
        "Review & Submit",
    ];

    const handleNext = () => {
        if (!validateStep(activeStep)) return;
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleRoleChange = (e) => {
        const role = e.target.value;
        dispatch(getJobCategories(role));
        setForm({
            ...form,
            role_id: role,
            title:
                role === "5"
                    ? "Job For Teachers & Assistants"
                    : "Job For Support Staffing Roles",
        });
    };

    const validateStep = (step) => {
        switch (step) {
            case 0:
                if (!form.role_id) {
                    toast.error("Please select a role to continue.");
                    return false;
                }
                if (!form.title) {
                    toast.error("Please enter a job title.");
                    return false;
                }
                if (!form.categories) {
                    toast.error("Please select a job category.");
                    return false;
                }
                if (!form.job_type) {
                    toast.error("Please select job type.");
                    return false;
                }
                if (
                    form.experience_level === "" ||
                    form.experience_level === null
                ) {
                    toast.error("Please enter experience required.");
                    return false;
                }

                if (Number(form.experience_level) < 0) {
                    toast.error("Experience cannot be a negative value.");
                    return false;
                }

                return true;
            case 1:
                if (!form.city) {
                    toast.error("Please enter city.");
                    return false;
                }
                if (!form.state) {
                    toast.error("Please select state.");
                    return false;
                }
                if (!form.salary_min || !form.salary_max) {
                    toast.error("Please enter salary range.");
                    return false;
                }

                if (Number(form.salary_min) < 0 || Number(form.salary_max) < 0) {
                    toast.error("Salary cannot be a negative amount.");
                    return false;
                }

                if (Number(form.salary_min) > Number(form.salary_max)) {
                    toast.error("Minimum salary cannot be greater than maximum salary.");
                    return false;
                }
                return true;
            case 2:
                if (!form.duration) {
                    toast.error("Please enter job duration.");
                    return false;
                }
                if (Number(form.duration) < 0) {
                    toast.error("Duration cannot be a negative value.");
                    return false;
                }
                if (!form.no_of_jobs) {
                    toast.error("Please enter number of openings.");
                    return false;
                }
                if (Number(form.no_of_jobs) < 0) {
                    toast.error("No of Jobs cannot be a negative value.");
                    return false;
                }
                return true;
            default:
                return true;
        }
    };

    const handleSubmit = () => {
        const token = localStorage.getItem("token");
        const formData = new FormData();
        Object.entries(form).forEach(([key, value]) => formData.append(key, value));

        dispatch(addJob({ token, formData }))
            .unwrap()
            .then(() => {
                toast.success("Job added successfully!");
                navigate("/panel/my-job");
            })
            .catch(() => toast.error("Failed to add job."));
    };

    return (
        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
            <div className="ps-2 ps-lg-4">
                <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">Add New Job</h4>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <div className="mt-4">
                    {activeStep === 0 && (
                        <>
                            {/* Role selection as radio buttons */}
                            <FormControl component="fieldset" margin="normal">
                                <RadioGroup
                                    row
                                    name="role_id"
                                    value={form.role_id}
                                    onChange={handleRoleChange}
                                >
                                    <FormControlLabel value="5" control={<Radio />} label="Teachers & Assistants" />
                                    <FormControlLabel value="6" control={<Radio />} label="Support Staffing Roles" />
                                </RadioGroup>
                            </FormControl>

                            {/* Show rest of the fields only if a role is selected */}
                            {form.role_id && (
                                <>
                                    {/* Job Title */}
                                    <TextField
                                        label="Job Title"
                                        fullWidth
                                        name="title"
                                        value={form.title}
                                        onChange={handleChange}
                                        margin="normal"
                                    />

                                    {/* Category */}
                                    <FormControl fullWidth margin="normal" variant="outlined">
                                        <InputLabel id="category-label">Category</InputLabel>
                                        <Select
                                            labelId="category-label"
                                            label="Category"
                                            name="categories"
                                            value={form.categories}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="">-- Select --</MenuItem>
                                            {jobCategories?.map((cat) => (
                                                <MenuItem key={cat.id} value={cat.id}>
                                                    {cat.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>


                                    {/* Job Type */}
                                    <FormControl component="fieldset" margin="normal">
                                        <FormLabel id="demo-row-radio-buttons-group-label">Job Type</FormLabel>
                                        <RadioGroup
                                            row
                                            name="job_type"
                                            value={form.job_type}
                                            onChange={handleChange}
                                        >
                                            <FormControlLabel value="Full-Time" control={<Radio />} label="Full-Time" />
                                            <FormControlLabel value="Part-Time" control={<Radio />} label="Part-Time" />
                                            <FormControlLabel value="Internship" control={<Radio />} label="Internship" />
                                        </RadioGroup>
                                    </FormControl>

                                    {/* Experience */}
                                    <TextField
                                        label="Experience (Years)"
                                        type="number"
                                        name="experience_level"
                                        value={form.experience_level}
                                        onChange={handleChange}

                                        margin="normal"
                                    />
                                </>
                            )}
                        </>
                    )}


                    {activeStep === 1 && (
                        <>
                            <TextField
                                label="City"
                                name="city"
                                value={form.city}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                            <FormControl fullWidth margin="normal" variant="outlined">
                                <InputLabel id="state-label">State</InputLabel>
                                <Select
                                    name="state"
                                    label="State"
                                    labelId="state-label"
                                    value={form.state}
                                    onChange={handleChange}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300, // dropdown max height
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem value="">-- Select State --</MenuItem>
                                    {stats.map((cat) => (
                                        <MenuItem key={cat.id} value={cat.id}>
                                            {cat.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>


                            <div className="d-flex gap-3 mt-2">
                                <TextField
                                    label="Salary Min"
                                    name="salary_min"
                                    type="number"
                                    value={form.salary_min}
                                    onChange={handleChange}
                                />
                                <TextField
                                    label="Salary Max"
                                    name="salary_max"
                                    type="number"
                                    value={form.salary_max}
                                    onChange={handleChange}
                                />
                                <FormControl>
                                    <Select name="currency" value={form.currency} onChange={handleChange}>
                                        <MenuItem value="USD">USD</MenuItem>
                                        <MenuItem value="EUR">EUR</MenuItem>
                                        <MenuItem value="GBP">GBP</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </>
                    )}

                    {activeStep === 2 && (
                        <>
                            <TextField
                                label="Duration"
                                name="duration"
                                type="number"
                                value={form.duration}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                            <TextField
                                label="No. of Openings"
                                name="no_of_jobs"
                                type="number"
                                value={form.no_of_jobs}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                            {/* <TextField
                                label="Job Description"
                                name="description"
                                value={form.description}
                                onChange={handleChange}
                                multiline
                                rows={4}
                                fullWidth
                                margin="normal"
                            /> */}
                            <FormControl fullWidth margin="normal">
                                <label className="form-label text-primary mb-1 font-weight-semibold">Provide some Details of Job</label>
                                <QuillEditor
                                    onChange={(val) => setForm(prev => ({ ...prev, description: val }))}
                                />
                            </FormControl>

                        </>
                    )}

                    {activeStep === 3 && (
                        <Paper elevation={3} sx={{ p: 4, mt: 3, borderRadius: 3 }}>
                            <Typography variant="h5" gutterBottom fontWeight="bold" color="primary">
                                Review Your Job Details
                            </Typography>
                            <Divider sx={{ mb: 3 }} />

                            <Grid container spacing={2}>
                                {/* Left Column */}
                                <Grid item xs={12} sm={6}>
                                    <Typography mb={1}><strong>Role:</strong> {form.role_id === "5" ? "Teachers & Assistants" : "Support Staffing Roles"}</Typography>
                                    <Typography mb={1}><strong>Job Title:</strong> {form.title}</Typography>
                                    <Typography mb={1}><strong>Category:</strong> {jobCategories?.find(c => c.id === form.categories)?.name || ""}</Typography>
                                    <Typography mb={1}><strong>Job Type:</strong> {form.job_type}</Typography>
                                    <Typography mb={1}><strong>Experience:</strong> {form.experience_level} years</Typography>
                                </Grid>

                                {/* Right Column */}
                                <Grid item xs={12} sm={6}>
                                    <Typography mb={1}><strong>City:</strong> {form.city}</Typography>
                                    <Typography mb={1}><strong>State:</strong> {stats.find(s => s.id === form.state)?.name || ""}</Typography>
                                    <Typography mb={1}><strong>Salary:</strong> {form.salary_min} - {form.salary_max} {form.currency}</Typography>
                                    <Typography mb={1}><strong>Duration:</strong> {form.duration} months</Typography>
                                    <Typography mb={1}><strong>No. of Openings:</strong> {form.no_of_jobs}</Typography>
                                </Grid>

                                {/* Description (Full width) */}
                                <Grid item xs={12}>
                                    <Typography mb={1}><strong>Description:</strong></Typography>
                                    <Paper
                                        variant="outlined"
                                        sx={{ p: 2, mt: 1, backgroundColor: "#f9f9f9", borderRadius: 1, whiteSpace: 'pre-wrap' }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: form.description }} />
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Paper>
                    )}

                    <div className="mt-4 d-flex justify-content-between">
                        <Button disabled={activeStep === 0} onClick={handleBack}>
                            Back
                        </Button>
                        {activeStep === steps.length - 1 ? (
                            <Button variant="contained" onClick={handleSubmit} disabled={loading}>
                                {/* Submit Job */}
                                {loading ? "Saving..." : "Submit Job"}
                            </Button>
                        ) : (
                            <Button variant="contained" onClick={handleNext}>
                                Next
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkerAddJobAI;
